<template>
  <div class="blik-invoice-waiting">
    <div class="blik-invoice-waiting__icon" aria-hidden="true">
      <svg
        width="50"
        height="78"
        viewBox="0 0 50 78"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-inside-1_1_1210" fill="white">
          <path
            d="M0 11C0 4.92487 4.92487 0 11 0H39C45.0751 0 50 4.92487 50 11V67C50 73.0751 45.0751 78 39 78H11C4.92487 78 0 73.0751 0 67V11Z" />
        </mask>
        <path
          d="M11 0V3H39V0V-3H11V0ZM50 11H47V67H50H53V11H50ZM39 78V75H11V78V81H39V78ZM0 67H3V11H0H-3V67H0ZM11 78V75C6.58172 75 3 71.4183 3 67H0H-3C-3 74.732 3.26802 81 11 81V78ZM50 67H47C47 71.4183 43.4183 75 39 75V78V81C46.732 81 53 74.732 53 67H50ZM39 0V3C43.4183 3 47 6.58172 47 11H50H53C53 3.26801 46.732 -3 39 -3V0ZM11 0V-3C3.26801 -3 -3 3.26802 -3 11H0H3C3 6.58172 6.58172 3 11 3V0Z"
          fill="currentColor"
          mask="url(#path-1-inside-1_1_1210)" />
        <path
          d="M19 67.5C19 66.6716 19.6716 66 20.5 66H29.5C30.3284 66 31 66.6716 31 67.5C31 68.3284 30.3284 69 29.5 69H20.5C19.6716 69 19 68.3284 19 67.5Z"
          fill="currentColor" />
      </svg>
    </div>

    <h2 class="blik-invoice-waiting__title">{{ $t('blik_invoice__waiting_title') }}</h2>
    <p class="blik-invoice-waiting__text">{{ $t('blik_invoice__waiting_text') }}</p>

    <div class="blik-invoice-waiting__spinner" aria-hidden="true"></div>

    <button type="button" class="blik-invoice-waiting__cancel" @click="$emit('cancel')">
      {{ $t('blik_invoice__waiting_cancel') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'BlikInvoiceWaitingScreen',
};
</script>

<style lang="scss">
.blik-invoice-waiting {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &__icon {
    color: #5b5b61;
    margin-bottom: 22px;
  }

  &__title {
    margin: 0 0 12px;
    font-size: 28px;
    line-height: 34px;
    font-weight: 700;
    color: #161616;
  }

  &__text {
    margin: 0 0 24px;
    max-width: 340px;
    font-size: 16px;
    line-height: 24px;
    color: #5b5b61;
  }

  &__spinner {
    width: 54px;
    height: 54px;
    margin-bottom: 34px;
    border: 5px solid #f0c5d1;
    border-top-color: #e52222;
    border-radius: 50%;
    animation: blik-invoice-waiting-spin 0.8s linear infinite;
  }

  &__cancel {
    width: 100%;
    height: 50px;
    border: 1px solid #d9d9de;
    border-radius: 12px;
    background: transparent;
    color: #161616;
    font-size: 15px;
    line-height: 18px;
    font-weight: 700;
    cursor: pointer;
  }

  @media (max-width: 570px) {
    &__title {
      font-size: 23px;
      line-height: 28px;
    }
  }
}

@keyframes blik-invoice-waiting-spin {
  to {
    transform: rotate(360deg);
  }
}

html[data-color-scheme='dark'] {
  .blik-invoice-waiting {
    &__title,
    &__cancel {
      color: #ffffff;
    }

    &__text,
    &__icon {
      color: #e0e0e0;
    }

    &__spinner {
      border-color: #6a4a54;
      border-top-color: #e74f58;
    }

    &__cancel {
      border-color: #d9d9de;
    }
  }
}
</style>
